import { FC, useEffect, useState } from "react";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { downloadDocument } from "../../../../apis/patientService";
import { message } from "antd";
import { errorMessage } from "../../../../utils/notificationUtils";
import { fetchEchsUnlistedProcedure } from "../../../../apis/SchemeService/ECHS/echsService";
import ViewUnlistedProcedureEchs from "../../../../components/patient/Enhancement/ECHS/ViewUnlistedProcedureEchs";
import ViewDocumentEchs from "../../../../components/patient/Enhancement/ECHS/ViewDocumentEchs";
import { getDeficiencyQuestionData } from "../../../../models/patientSlice";

type ViewUnlistedProcedureContainerEchsProps = {
  viewUnlistedProcedureEchs: boolean;
  closeViewUnlistedProcedure: any;
};

const ViewUnlistedProcedureContainerEchs: FC<
  ViewUnlistedProcedureContainerEchsProps
> = ({ viewUnlistedProcedureEchs, closeViewUnlistedProcedure }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients } = useSelector((state: RootState) => state);
  const [enhancementData, setEnhancementData] = useState<any>([]);
  const [isFetchingEnhancementData, setIsFetchingEnhancementData] =
    useState<boolean>(false);
  const [documentName, setDocumentName] = useState("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);

  const handleOpen = (documentList: any, docType: any) => {
    setPreviewDocument(true);
    setDocumentUrls(documentList);
    setClickedActiveTab(docType);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any,
  ) => {
    try {
      if (selectedDocumentId) {
        await dispatch(getDeficiencyQuestionData(selectedDocumentId));
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any,
  ) => {
    await fetchDeficiencyData(document, document?.id);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      message.success("Document Downloaded successfully");
    } catch (error) {
      message.error("Download failed");
    }
  };

  const fetchData = async () => {
    try {
      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        setIsFetchingEnhancementData(true);
        const res: any = await fetchEchsUnlistedProcedure(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
        );
        if (res && Array.isArray(res)) {
          setEnhancementData(res);
        }
        setIsFetchingEnhancementData(false);
      }
    } catch (error: any) {
      errorMessage(error.message || "Please, Try again later");
      setIsFetchingEnhancementData(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    viewUnlistedProcedureEchs,
  ]);

  return (
    <div>
      <ViewUnlistedProcedureEchs
        viewUnlistedProcedureEchs={viewUnlistedProcedureEchs}
        closeViewUnlistedProcedure={closeViewUnlistedProcedure}
        handleOpen={handleOpen}
        isFetchingEnhancementData={isFetchingEnhancementData}
        enhancementsList={enhancementData}
      />

      <ViewDocumentEchs
        handleCancel={handleCancelPreview}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        clickedActiveTab={clickedActiveTab}
      />
    </div>
  );
};

export default ViewUnlistedProcedureContainerEchs;
